import { ModalContextState } from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export const initialModalContextState: ModalContextState = {
  showModal: noop,
  hideModal: noop,
};

export const ModalContext = createContext(initialModalContextState);

export const useModalContext = () => useContext(ModalContext);
